module.exports = __webpack_public_path__ + "static/media/hi.26265460.png";